import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { MotivationalProfile } from "@/components/MotivationalProfile";
import { Ban, CheckCircle2, MailCheck } from "lucide-react";

export default function CompletionPage() {
  const navigate = useNavigate();
  const [result, setResult] = useState(null);

  useEffect(() => {
    const sid = localStorage.getItem("its_test_session");
    if (!sid) { setResult({ status: "unknown" }); return; }
    api.get(`/tests/${sid}/result`).then(({ data }) => setResult(data)).catch(() => setResult({ status: "unknown" }));
  }, []);

  if (!result) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center" data-testid="completion-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-[#003366]" />
      </div>
    );
  }

  if (result.status === "terminated") {    return (
      <div className="min-h-screen bg-[#F8FAFC]">
        <Header />
        <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="completion-terminated">
          <Ban className="h-14 w-14 text-red-500 mx-auto mb-4" />
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Sessione annullata</h1>
          <p className="mt-3 text-slate-600 text-sm max-w-md mx-auto">
            {result.terminated_reason || "La sessione è stata terminata per violazione delle regole di proctoring."}
          </p>
          <Button data-testid="completion-terminated-back" className="mt-6 bg-[#003366] hover:bg-[#002244]" onClick={() => navigate("/dashboard")}>
            Torna all'area riservata
          </Button>
        </div>
      </div>
    );
  }

  // Completata o screened_out: stessa notifica, nessun punteggio del test comunicato
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <div className="max-w-3xl mx-auto px-4 py-20 fade-up" data-testid="completion-success">
        <div className="text-center">
          <CheckCircle2 className="h-14 w-14 text-green-600 mx-auto mb-4" />
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
            Fase di selezione completata
          </h1>
          <p className="mt-4 text-base text-slate-600 leading-relaxed max-w-lg mx-auto">
            {result.instrument_version === "itsmatch-rotta-4.0.0"
              ? "Risposte inviate. Saranno utilizzate dalla commissione per preparare il colloquio. Se necessario, l'ITS ti inviterà a confermare o aggiornare alcune informazioni."
              : "Hai completato la fase di selezione online. La commissione esaminatrice valuterà la tua prova e la tua candidatura: sarai ricontattato dall'istituto per gli esiti e gli eventuali passaggi successivi."}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-sm text-blue-900">
            <MailCheck className="h-4 w-4" />
            Abbiamo inviato una conferma di completamento al tuo indirizzo email.
          </div>
        </div>

        {result.motivational_profile && (
          <Card className="institutional-card mt-10 text-left" data-testid="completion-motivational">
            <CardContent className="p-6">
              <p className="eyebrow mb-1">Il tuo questionario</p>
              <h2 className="font-display text-xl font-bold text-slate-900 mb-1">Profilo motivazionale orientativo</h2>
              <MotivationalProfile profile={result.motivational_profile} />
            </CardContent>
          </Card>
        )}

        <div className="mt-8 text-center">
          <Button data-testid="completion-back-dashboard" className="bg-[#003366] hover:bg-[#002244]" onClick={() => navigate("/dashboard")}>
            Torna all'area riservata
          </Button>
        </div>
      </div>
    </div>
  );
}
